import QuanLiTaiSanPage from 'components/quan-li-tai-san/QuanLiTaiSanPage';
import { ASSET_SOURCE } from 'config/constants/assetConstant';
import React from 'react';

function NoiTruQuanLiTaiSanPage() {
    return <QuanLiTaiSanPage assetSource={ASSET_SOURCE.NOITRU}></QuanLiTaiSanPage>;
}

export default NoiTruQuanLiTaiSanPage;
